import {
    tss,
} from 'app/tss'

export default tss.withNestedSelectors<'icon'>().create(({
    theme,
    classes,
}) => {
    return {
        cardBody: {
            [`&:hover .${classes.icon}`]: {
                width: 70,
                padding: theme.spacing(2),
            },
        },
        column: {
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
            flexDirection: 'column',
        },
        tight: {
            alignContent: 'baseline !important',
            top: theme.spacing(0.4),
            position: 'absolute',
            '& button': {
                margin: '1px !important',
            },
        },
        icon: {
            width: 100,
            padding: theme.spacing(4),
            transform: 'transition(all 0.2s linear)',
            transition: 'all 0.2s linear',
        },
    }
})
